import { RefObject, useEffect } from 'react';

// Any of these means the user took over the scroll
const userScrollEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'] as const;

/**
 * Scrolls the element to the top of the page each time a new request (any new non-null value) is received. The content
 * above it may still be loading and push it down, so it is kept in place while the page resizes, until the user
 * scrolls or maxWaitMs elapses. The offset from the top (e.g. the fixed navbar) is set with scroll-margin-top.
 */
export function useScrollIntoViewOnRequest(ref: RefObject<HTMLElement>, request: unknown, maxWaitMs = 3000) {
    useEffect(() => {
        const element = ref.current;
        if (!request || !element) return;

        const scroll = () => element.scrollIntoView?.({ block: 'start' });
        scroll();

        if (typeof ResizeObserver === 'undefined') return;

        const observer = new ResizeObserver(scroll);
        observer.observe(document.body);

        const stop = () => {
            observer.disconnect();
            clearTimeout(timeout);
            userScrollEvents.forEach((type) => window.removeEventListener(type, stop));
        };
        const timeout = setTimeout(stop, maxWaitMs);
        userScrollEvents.forEach((type) => window.addEventListener(type, stop, { passive: true }));

        return stop;
    }, [ref, request, maxWaitMs]);
}
